<template>
  <svg
    class="svg-icon"
    width="16"
    height="2"
    viewBox="0 0 16 2"
    xmlns="http://www.w3.org/2000/svg"
    tabindex="0"
    role="button"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
    @mousedown="handleMouseDown"
    @mouseup="handleMouseUp"
    @keydown.enter="handleActive"
    @keyup.enter="handleInactive"
  >
    <rect
      width="16"
      height="2"
      rx="1"
      :fill="currentColor"
    />
  </svg>
</template>

<script>
  export default {
    props: {
      color: {
        type: String,
        default: '#C4C4C4',
      },
      hoverColor: {
        type: String,
        default: '#57a9dd',
      },
      activeColor: {
        type: String,
        default: '#2985BF',
      },
    },
    data() {
      return {
        currentColor: this.color,
        isActive: false,
      };
    },
    methods: {
      handleMouseEnter() {
        if (!this.isActive) {
          this.currentColor = this.hoverColor;
        }
      },
      handleMouseLeave() {
        if (!this.isActive) {
          this.currentColor = this.color;
        }
      },
      handleMouseDown() {
        this.isActive = true;
        this.currentColor = this.activeColor;
      },
      handleMouseUp() {
        this.isActive = false;
        this.currentColor = this.hoverColor;
      },
      handleActive() {
        this.isActive = true;
        this.currentColor = this.activeColor;
      },
      handleInactive() {
        this.isActive = false;
        this.currentColor = this.color;
      },
    },
  };
</script>
<style>
  .svg-icon {
    width: 17px;
    height: 17px;
    cursor: pointer;
    outline: none;
  }
</style>
